import People from "../people";

const Companies = (props) => <People {...props} company />;

export default Companies;
